<template>
    <div>
        <b-modal
            id="gradientModal"
            v-model="openModalShow"
            size="xxxl"
            ok-variant="success"
            ok-title="Confirmă"
            cancel-variant="danger"
            cancel-title="Anulează"
            header-bg-variant="gradient-color"
            body-bg-variant="gradient-color"
            hide-footer
            hide-header
            centered
            @hide="$emit('hideTempModal');"
        >

            <div class="modal-body">
                <b-overlay :show="acquisitionLoading" :opacity="opacity">
                    <template #overlay>
                        <div class="custom-loading-overlay">
                            <b-spinner class="mb-3"></b-spinner>
                            <p>{{ loadingText }}</p>
                        </div>
                    </template>
                    <div class="flex flex-mobilee">
                        <div class="modal-menu">
                            <div class="flex-menu-header">
                                <b-form-group class="has-search-icon">
                                    <b-form-input
                                        v-model="searchQuery"
                                        type="text"
                                        :placeholder="`Caută prin ${getSpendingsLength} repere`"
                                        @keyup="searchAndGetAchizitii(searchQuery)"
                                    >
                                    </b-form-input>
                                    <b-icon-search></b-icon-search>
                                </b-form-group>
                                <img src="@/assets/images/M3/M3Sketch/smis-hub-logo.svg" style="max-width: 116px;">
                            </div>
                            <div v-if="searchQuery && searchQuery.length" class="reper-title mt-2 mb-2">
                                Rezultatele căutării
                            </div>
                            <ul v-if="searchQuery && searchQuery.length && productsSearched.length > 0" class="flex-repers">
                                <li v-for="(spending, key) in productsSearched" :key="key" class="search-reper col-lg-6 col-md-12" @click="addProduct(spending.id)">
                                    <div class="reper-info">
                                        <div class="reper-label" :class="getClassBySpending(spending)"></div>
                                        <p :id="'title'+key" class="mb-0">{{ spending.title.substring(0, 25) }} <span v-if="spending.title.length > 25">...</span></p>
                                        <b-tooltip v-if="spending.title.length > 25" :target="'title'+key">{{ spending.title }}</b-tooltip>
                                        <p :id="'subtitle'+key" style="font-size: 10px">{{ spending.subtitle.substring(0, 25) }} <span v-if="spending.subtitle.length > 25">...</span></p>
                                        <b-tooltip v-if="spending.subtitle.length > 25" :target="'subtitle'+key">{{ spending.subtitle }}</b-tooltip>
                                        <p style="font-size: 16px; font-weight: 300;">
                                            {{ spending.display_price }}
                                            <img v-if="spending.eligible" src="@/assets/images/M3/M3Sketch/procentMediu.png" alt="Procent de mediu" :class="Number(spending.contribution_percentage) !== 100 ? 'gray-leaf' : ''" style="width: 13px; height: 16px; margin-left: 10px;">
                                            <b-icon-x-circle-fill v-else style="color: #ff4141;"></b-icon-x-circle-fill>
                                        </p>
                                    </div>
                                    <div class="reper-image">
                                        <img :src="spending.logo" :alt="spending.subtitle">
                                    </div>
                                </li>
                            </ul>
                            <p v-if="searchQuery && searchQuery.length && productsSearched.length < 1" class="no-user-spendings" style="color: #9197ab; margin-bottom: 20px;">Nu există rezultate.</p>
                            <div class="reper-title green-title mt-2 mb-1" @click="userVisible = !userVisible">
                                Reperele tale
                                <b-icon-arrow-right v-if="!userVisible"></b-icon-arrow-right>
                                <b-icon-arrow-down v-else></b-icon-arrow-down>
                            </div>
                            <b-collapse id="collapse-1" v-model="userVisible" class="mt-2">
                                <ul v-if="userSpendings.length">
                                    <li v-for="(spending, key) in userSpendings" :key="key" class="personal-reper" @click="selectUserSpending(key)">
                                        <span style="cursor: pointer">{{ spending.title }}</span>
                                        <div class="reper-actions" :class="!spending.display_price ? 'reper-one-action' : ''">
                                            <span v-if="spending.display_price" class="green-price-small">{{ spending.display_price }} lei</span>
                                            <b-icon-trash style="cursor: pointer" class="reper-icon"
                                                          @click.stop="deleteUserSpending(spending.id)"
                                            ></b-icon-trash>
                                        </div>
                                    </li>
                                </ul>
                                <span v-else class="no-user-spendings">Nu aveți repere salvate!</span>
                            </b-collapse>
                            <div>
                                <ReferenceProduct v-for="(category, key) in listareProduse" :key="key" :search="searchQuery" :categoryKey="category.id"
                                                  :category="category" @addProduct="addProduct($event)"
                                ></ReferenceProduct>
                            </div>
                        </div>
                        <div class="modal-body-content">
                            <div class="modal-header flex space-between">
                                <span class="mb-3">Adaugă detaliile despre <strong>cheltuială / achiziție</strong></span>
                                <div class="flex mobileFlexToo">
                                    <div class="flex align-center delete-button" @click="resetFields()">
                                        <p>Șterge toate câmpurile</p>
                                        <b-icon-trash font-scale="1.3"></b-icon-trash>
                                    </div>
                                    <div class="close-add-achizitie" @click="$emit('hideTempModal')">
                                        <b-icon-x font-scale="1.5"></b-icon-x>
                                    </div>
                                </div>
                            </div>
                            <validation-observer #default="{ invalid }" ref="aquisitionForm">
                                <span class="display-none">{{ invalid }}</span>
                                <b-form>
                                    <div class="form-content pb-0">
                                        <div class="inputs-group mb-2 flex mobile-column wrap-medium" style="justify-content: space-between;">
                                            <validation-provider
                                                #default="{ errors }"
                                                rules="required"
                                                class="col-md-12 col-lg-6"
                                                style="max-width: 550px;"
                                            >
                                                <b-form-group label="Descrierea cheltuielii">
                                                    <b-form-input
                                                        v-model="form.subcategories.acquisitions.description"
                                                        type="text"
                                                        :state="errors.length > 0 ? false : null"
                                                    ></b-form-input>
                                                    <img
                                                        v-if="checkLength(form.subcategories.acquisitions.description) && !errors[0]"
                                                        src="@/assets/images/checkMark.png" class="checkMark"
                                                    >
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </b-form-group>
                                            </validation-provider>
                                            <div class="col-md-12 col-lg-6 min-width-desktop width100Mobile" style="display: flex; align-items: center; justify-content: space-between; padding: 0;">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    rules="required"
                                                    style="padding: 0 5px; width: 50%;"
                                                >
                                                    <b-form-group label="Categorie">
                                                        <v-select
                                                            v-model="form.category_no"
                                                            class="changeCompany"
                                                            dir="ltr"
                                                            :options="getCategories"
                                                            :class="errors.length > 0 || categoryNoError ? 'is-invalid' : ''"
                                                            :reduce="(option) => option.id"
                                                            label="name"
                                                            input-id="id"
                                                            :clearable="false"
                                                            @input="categoryChanged()"
                                                        ></v-select>
                                                        <img v-if="form.category_no && !errors[0]"
                                                             src="@/assets/images/checkMark.png" class="checkMark"
                                                        >
                                                        <small class="text-danger" style="position: absolute; bottom: -20px;">{{ errors[0] }}</small>
                                                        <small v-if="categoryNoError" class="text-danger" style="position: absolute; bottom: -20px;">Te rugăm să schimbi categoria.</small>
                                                    </b-form-group>
                                                </validation-provider>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    rules="required"
                                                    style="padding: 0 5px; width: 50%;"
                                                >
                                                    <b-form-group label="Subcategorie">
                                                        <v-select
                                                            v-model="form.subcategories.subcategory_no"
                                                            class="changeCompany"
                                                            dir="ltr"
                                                            :options="getSubcategories"
                                                            :reduce="(option) => option.id"
                                                            :class="errors.length > 0 || subcategoryNoError ? 'is-invalid' : ''"
                                                            label="name"
                                                            input-id="id"
                                                            :clearable="true"
                                                            @input="subcategoryNoError = false"
                                                        >
                                                            <span slot="no-options">
                                                                Selectează mai întâi categoria.
                                                            </span>
                                                        </v-select>
                                                        <img v-if="checkLength(form.subcategories.subcategory_no) && !errors[0]"
                                                             src="@/assets/images/checkMark.png" class="checkMark"
                                                        >
                                                        <small class="text-danger" style="position: absolute; bottom: -20px;">{{ errors[0] }}</small>
                                                        <small v-if="subcategoryNoError" class="text-danger" style="position: absolute; bottom: -20px;">Te rugăm să schimbi subcategoria.</small>
                                                    </b-form-group>
                                                </validation-provider>
                                            </div>
                                        </div>
                                        <div class="inputs-group flex mobile-column wrap-medium">
                                            <validation-provider
                                                #default="{ errors }"
                                                rules="required"
                                                class="first-input col-md-12 col-lg-6 h-100"
                                                style="width: 50%; max-width: 550px;"
                                            >
                                                <b-form-group label="Justificare/fundamentare cheltuială">
                                                    <b-form-textarea
                                                        v-model="form.subcategories.acquisitions.justificare"
                                                        rows="4"
                                                        style="min-height: 100px;"
                                                        :state="errors.length > 0 ? false : null"
                                                        @keyup="limitCharacters()"
                                                    ></b-form-textarea>
                                                    <img
                                                        v-if="checkLength(form.subcategories.acquisitions.justificare) && !errors[0]"
                                                        src="@/assets/images/checkMark.png" class="checkMark"
                                                    >
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                    <p>Maxim 300 de caractere</p>
                                                </b-form-group>
                                            </validation-provider>
                                            <div class="wrap-medium-inputs">
                                                <div class="flex">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="medium-input"
                                                        name="preț unitar"
                                                    >
                                                        <b-form-group label="Preț unitar LEI - fără TVA">
                                                            <b-form-input
                                                                v-model="unitPriceWithoutVat"
                                                                type="number" step=".01"
                                                                :state="errors.length > 0 ? false : null"
                                                                :class="negativeNumbers.pret_unitar_fara_tva ? 'is-invalid' : ''"
                                                                @keyup="unitPriceWithoutVat ? valueChangedForUnitPriceWithoutVat() : ''"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="checkLength(unitPriceWithoutVat) && !errors[0] && !negativeNumbers.pret_unitar_fara_tva"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                            <small v-if="negativeNumbers.pret_unitar_fara_tva"
                                                                   class="text-danger"
                                                            >Valoarea nu poate fi negativă</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="small-input"
                                                    >
                                                        <b-form-group label="Cantitate">
                                                            <b-form-input
                                                                v-model="form.subcategories.acquisitions.cantitate"
                                                                type="number"
                                                                :state="errors.length > 0 ? false : null"
                                                                :class="negativeNumbers.cantitate ? 'is-invalid' : ''"
                                                                @keyup="calculateFaraTVA()"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="form.subcategories.acquisitions.cantitate > 0 && !errors[0] && !negativeNumbers.cantitate"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                            <small v-if="negativeNumbers.cantitate" class="text-danger">Valoarea
                                                                nu poate fi negativă</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="small-input"
                                                    >
                                                        <b-form-group label="U.M.">
                                                            <b-form-input
                                                                v-model="form.subcategories.acquisitions.um"
                                                                type="text"
                                                                :state="errors.length > 0 ? false : null"
                                                                @keyup="calculateFaraTVA()"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="form.subcategories.acquisitions.um && form.subcategories.acquisitions.um.length > 0 && !errors[0]"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="small-input"
                                                    >
                                                        <b-form-group label="Cota TVA %">
                                                            <b-form-input
                                                                v-model="form.subcategories.acquisitions.cota_tva"
                                                                default="19"
                                                                type="number"
                                                                :min="0"
                                                                :state="errors.length > 0 ? false : null"
                                                                :class="negativeNumbers.cota_tva ? 'is-invalid' : ''"
                                                                @keyup="form.subcategories.acquisitions.cota_tva ? calculateOnChangeCotaTVA() : ''"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="form.subcategories.acquisitions.cota_tva && !errors[0] && !negativeNumbers.cota_tva"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                            <small v-if="negativeNumbers.cota_tva" class="text-danger">Valoarea
                                                                nu poate fi negativă</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="small-medium-input"
                                                    >
                                                        <b-form-group label="Total (fără TVA)">
                                                            <b-form-input
                                                                :model="form.subcategories.acquisitions.total ? form.subcategories.acquisitions.total.toFixed(2) : ''"
                                                                step=".01" readonly
                                                                :value="form.subcategories.acquisitions.total ? form.subcategories.acquisitions.total.toFixed(2) : ''"
                                                                type="number" :state="errors.length > 0 ? false : null"
                                                                @keyup="calculateFaraTVA()"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="form.subcategories.acquisitions.total > 0 && !errors[0]"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger"
                                                                   style="white-space: pre;"
                                                            >{{ errors[0] }}</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="small-medium-input"
                                                    >
                                                        <b-form-group label="Total (TVA inclus)">
                                                            <b-form-input
                                                                :model="Number(form.subcategories.acquisitions.total_cu_tva).toFixed(2)"
                                                                step=".01" readonly
                                                                :value="Number(form.subcategories.acquisitions.total_cu_tva).toFixed(2)"
                                                                type="number"
                                                                :state="errors.length > 0 ? false : null"
                                                                @keyup="calculateFaraTVA()"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="form.subcategories.acquisitions.total_cu_tva > 0 && !errors[0]"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </div>
                                                <div class="flex mt-2">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        rules="required"
                                                        class="medium-input"
                                                    >
                                                        <b-form-group label="Preț unitar LEI - TVA inclus">
                                                            <b-form-input v-model="unitPriceWithVat"
                                                                          step=".01"
                                                                          type="number"
                                                                          :state="errors.length > 0 ? false : null"
                                                                          :class="negativeNumbers.pret_unitar_cu_tva ? 'is-invalid' : ''"
                                                                          @keyup="unitPriceWithVat ? valueChangedForUnitPriceWithVat() : ''"
                                                            ></b-form-input>
                                                            <img
                                                                v-if="checkLength(unitPriceWithVat) && !errors[0] && !negativeNumbers.pret_unitar_cu_tva"
                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                            >
                                                            <small class="text-danger mb-2"
                                                                   style="display: block;"
                                                            >{{ errors[0] }}</small>
                                                            <small v-if="negativeNumbers.pret_unitar_cu_tva"
                                                                   class="text-danger"
                                                            >Valoarea nu poate fi negativă</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                    <!--                                                <div style="width: 37%;" class="padding-left-mobile">-->
                                                    <!--                                                    <validation-provider-->
                                                    <!--                                                        #default="{ errors }"-->
                                                    <!--                                                        rules="required"-->
                                                    <!--                                                        class="full-width-input mb-2"-->
                                                    <!--                                                    >-->
                                                    <!--                                                        <b-form-group label="Alege activitatea proiectului">-->
                                                    <!--                                                            <v-select-->
                                                    <!--                                                                v-model="form.subcategories.acquisitions.activitatea_proiectului"-->
                                                    <!--                                                                dir="ltr"-->
                                                    <!--                                                                :options="getActivities"-->
                                                    <!--                                                                :reduce="(option) => option.id"-->
                                                    <!--                                                                :class="errors.length > 0 ? 'is-invalid' : ''"-->
                                                    <!--                                                                label="name"-->
                                                    <!--                                                                input-id="id"-->
                                                    <!--                                                                :state="errors.length > 0 ? false : null"-->
                                                    <!--                                                                @input="activityChanged()"-->
                                                    <!--                                                            ></v-select>-->
                                                    <!--                                                            <img-->
                                                    <!--                                                                v-if="form.subcategories.acquisitions.activitatea_proiectului && !errors[0]"-->
                                                    <!--                                                                src="@/assets/images/checkMark.png" class="checkMark"-->
                                                    <!--                                                            >-->
                                                    <!--                                                            <small class="text-danger"-->
                                                    <!--                                                                   style="position: absolute; bottom: -18px; right: 0;"-->
                                                    <!--                                                            >{{-->
                                                    <!--                                                                errors[0]-->
                                                    <!--                                                            }}</small>-->
                                                    <!--                                                        </b-form-group>-->
                                                    <!--                                                    </validation-provider>-->
                                                    <!--                                                </div>-->
                                                    <!--                                                <div style="width: 37%;" class="padding-right-mobile">-->
                                                    <!--                                                    <validation-provider-->
                                                    <!--                                                        #default="{ errors }"-->
                                                    <!--                                                        rules="required"-->
                                                    <!--                                                        class="full-width-input"-->
                                                    <!--                                                    >-->
                                                    <!--                                                        <b-form-group label="Alege subactivitatea proiectului">-->
                                                    <!--                                                            <v-select-->
                                                    <!--                                                                v-model="form.subcategories.acquisitions.subactivitatea_proiectului"-->
                                                    <!--                                                                dir="ltr"-->
                                                    <!--                                                                label="name"-->
                                                    <!--                                                                :options="getSubactivities"-->
                                                    <!--                                                                :class="errors.length > 0 ? 'is-invalid' : ''"-->
                                                    <!--                                                                :reduce="(option) => option.id"-->
                                                    <!--                                                                :state="errors.length > 0 ? false : null"-->
                                                    <!--                                                                input-id="id"-->
                                                    <!--                                                            ></v-select>-->
                                                    <!--                                                            <img-->
                                                    <!--                                                                v-if="form.subcategories.acquisitions.subactivitatea_proiectului && !errors[0]"-->
                                                    <!--                                                                src="@/assets/images/checkMark.png" class="checkMark"-->
                                                    <!--                                                            >-->
                                                    <!--                                                            <small class="text-danger"-->
                                                    <!--                                                                   style="position: absolute; bottom: -18px; right: 0;"-->
                                                    <!--                                                            >{{-->
                                                    <!--                                                                errors[0]-->
                                                    <!--                                                            }}</small>-->
                                                    <!--                                                        </b-form-group>-->
                                                    <!--                                                    </validation-provider>-->
                                                    <!--                                                </div>-->
                                                    <div class="flex flex-column full-w-responsive" style="width: 76%">
                                                        <!--<span class="title align-items-start mb-0" style="margin-bottom: 0 !important; padding-left: 5px !important; margin-top: 5px;">Valoarea eligibilă a cheltuielii</span>-->
                                                        <div class="flex space-between">
                                                            <validation-provider
                                                                #default="{ errors }"
                                                                rules="required"
                                                                style="width: 48.5%; padding: 0 4px;"
                                                            >
                                                                <b-form-group label="Valoarea eligibilă în LEI">
                                                                    <b-form-input
                                                                        v-model="processedEligible"
                                                                        :readonly="form.category_no===6"
                                                                        step=".01" type="number"
                                                                        :state="errors.length > 0 ? false : null"
                                                                        :class="eligibileNoTVAmore || negativeNumbers.eligible ? 'is-invalid' : ''"
                                                                        @change="checkTotalError()"
                                                                    ></b-form-input>
                                                                    <img
                                                                        v-if="!errors[0] && !eligibileNoTVAmore && !negativeNumbers.eligible"
                                                                        src="@/assets/images/checkMark.png" class="checkMark"
                                                                    >
                                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                                    <small
                                                                        v-if="eligibileNoTVAmore && allData && allData.vat_status == 'PLATITOR'"
                                                                        class="text-danger"
                                                                    >Valoarea depășește totalul fără
                                                                        TVA</small>
                                                                    <small
                                                                        v-if="eligibileNoTVAmore && allData && allData.vat_status == 'NEPLATITOR'"
                                                                        class="text-danger"
                                                                    >Valoarea depășește totalul cu
                                                                        TVA</small>
                                                                    <small v-if="negativeNumbers.eligible" class="text-danger">Valoarea
                                                                        nu poate fi negativă</small>
                                                                </b-form-group>
                                                            </validation-provider>
                                                            <validation-provider
                                                                #default="{ errors }"
                                                                rules="required"
                                                                style="width: 51.3%; padding: 0 4px;"
                                                            >
                                                                <b-form-group label="Valoare neeligibila in lei">
                                                                    <b-form-input
                                                                        v-model="processedNeeligible"
                                                                        step=".01" type="number"
                                                                        :state="errors.length > 0 ? false : null"
                                                                        :class="negativeNumbers.neeligible ? 'is-invalid' : ''"
                                                                        @change="calculateEligibleValues()"
                                                                    ></b-form-input>
                                                                    <img
                                                                        v-if="!errors[0] && !eligibleTVAmore && !negativeNumbers.neeligible"
                                                                        src="@/assets/images/checkMark.png" class="checkMark"
                                                                    >
                                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                                    <small v-if="eligibleTVAmore" class="text-danger">Valoarea
                                                                        depășește totalul cu TVA</small>
                                                                    <small v-if="negativeNumbers.neeligible"
                                                                           class="text-danger"
                                                                    >Valoarea nu poate fi
                                                                        negativă</small>
                                                                </b-form-group>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--                                            <div class="flex flex-column">-->
                                                <!--&lt;!&ndash;                                                <span class="title align-items-start mb-0" style="margin-bottom: 0 !important; padding-left: 5px !important; margin-top: 5px;">Valoarea eligibilă a cheltuielii</span>&ndash;&gt;-->
                                                <!--                                                <div class="flex space-between">-->
                                                <!--                                                    <validation-provider-->
                                                <!--                                                        #default="{ errors }"-->
                                                <!--                                                        rules="required"-->
                                                <!--                                                        style="width: 50%; padding: 0 4px;"-->
                                                <!--                                                    >-->
                                                <!--                                                        <b-form-group label="Valoarea eligibilă în LEI">-->
                                                <!--                                                            <b-form-input-->
                                                <!--                                                                v-model="processedEligible"-->
                                                <!--                                                                :readonly="form.category_no===6"-->
                                                <!--                                                                step=".01" type="number"-->
                                                <!--                                                                :state="errors.length > 0 ? false : null"-->
                                                <!--                                                                :class="eligibileNoTVAmore || negativeNumbers.eligible ? 'is-invalid' : ''"-->
                                                <!--                                                                @change="checkTotalError()"-->
                                                <!--                                                            ></b-form-input>-->
                                                <!--                                                            <img-->
                                                <!--                                                                v-if="!errors[0] && !eligibileNoTVAmore && !negativeNumbers.eligible"-->
                                                <!--                                                                src="@/assets/images/checkMark.png" class="checkMark"-->
                                                <!--                                                            >-->
                                                <!--                                                            <small class="text-danger">{{ errors[0] }}</small>-->
                                                <!--                                                            <small-->
                                                <!--                                                                v-if="eligibileNoTVAmore && allData && allData.vat_status == 'PLATITOR'"-->
                                                <!--                                                                class="text-danger"-->
                                                <!--                                                            >Valoarea depășește totalul fără-->
                                                <!--                                                                TVA</small>-->
                                                <!--                                                            <small-->
                                                <!--                                                                v-if="eligibileNoTVAmore && allData && allData.vat_status == 'NEPLATITOR'"-->
                                                <!--                                                                class="text-danger"-->
                                                <!--                                                            >Valoarea depășește totalul cu-->
                                                <!--                                                                TVA</small>-->
                                                <!--                                                            <small v-if="negativeNumbers.eligible" class="text-danger">Valoarea-->
                                                <!--                                                                nu poate fi negativă</small>-->
                                                <!--                                                        </b-form-group>-->
                                                <!--                                                    </validation-provider>-->
                                                <!--                                                    <validation-provider-->
                                                <!--                                                        #default="{ errors }"-->
                                                <!--                                                        rules="required"-->
                                                <!--                                                        style="width: 50%; padding: 0 4px;"-->
                                                <!--                                                    >-->
                                                <!--                                                        <b-form-group label="Valoare neeligibila in lei">-->
                                                <!--                                                            <b-form-input-->
                                                <!--                                                                v-model="processedNeeligible"-->
                                                <!--                                                                step=".01" type="number"-->
                                                <!--                                                                :state="errors.length > 0 ? false : null"-->
                                                <!--                                                                :class="negativeNumbers.neeligible ? 'is-invalid' : ''"-->
                                                <!--                                                                @change="calculateEligibleValues()"-->
                                                <!--                                                            ></b-form-input>-->
                                                <!--                                                            <img-->
                                                <!--                                                                v-if="!errors[0] && !eligibleTVAmore && !negativeNumbers.neeligible"-->
                                                <!--                                                                src="@/assets/images/checkMark.png" class="checkMark"-->
                                                <!--                                                            >-->
                                                <!--                                                            <small class="text-danger">{{ errors[0] }}</small>-->
                                                <!--                                                            <small v-if="eligibleTVAmore" class="text-danger">Valoarea-->
                                                <!--                                                                depășește totalul cu TVA</small>-->
                                                <!--                                                            <small v-if="negativeNumbers.neeligible"-->
                                                <!--                                                                   class="text-danger"-->
                                                <!--                                                            >Valoarea nu poate fi-->
                                                <!--                                                                negativă</small>-->
                                                <!--                                                        </b-form-group>-->
                                                <!--                                                    </validation-provider>-->
                                                <!--                                                </div>-->
                                                <!--                                            </div>-->
                                            </div>
                                        </div>
                                        <div class="inputs-group flex space-between mobileColumn mt-3 pl-2 mobilePl">
                                            <div class="w-50" style="margin-right: 20px; max-width: 520px;">
                                                <div class="flex flex-column">
                                                    <span class="title align-items-start mt-3 mb-2 no-space-left">Contribuția cheltuielii la <strong>&nbsp;obiectivele de mediu</strong></span>
                                                    <div class="flex align-items-end space-between">
                                                        <!--                                                        <validation-provider-->
                                                        <!--                                                            #default="{ errors }"-->
                                                        <!--                                                            rules="required"-->
                                                        <!--                                                            class=""-->
                                                        <!--                                                            style="width: 49%"-->

                                                        <!--                                                        >-->
                                                        <!--                                                            <b-form-group-->
                                                        <!--                                                                label="Valoarea în LEI (TVA inclus) care contribuie la obiectivele de mediu"-->
                                                        <!--                                                            >-->
                                                        <!--                                                                <b-form-input-->
                                                        <!--                                                                    v-model="processedContributionTotal"-->
                                                        <!--                                                                    step=".01" type="number"-->
                                                        <!--                                                                    :state="errors.length > 0 ? false : null"-->
                                                        <!--                                                                    :class="negativeNumbers.contribution_total ? 'is-invalid' : ''"-->
                                                        <!--                                                                    @change="calculateContributionValue()"-->
                                                        <!--                                                                ></b-form-input>-->
                                                        <!--                                                                <img v-if="!errors[0] && !negativeNumbers.contribution_total"-->
                                                        <!--                                                                     src="@/assets/images/checkMark.png" class="checkMark"-->
                                                        <!--                                                                >-->
                                                        <!--                                                                <small class="text-danger">{{ errors[0] }}</small>-->
                                                        <!--                                                                <small v-if="negativeNumbers.contribution_total"-->
                                                        <!--                                                                       class="text-danger"-->
                                                        <!--                                                                >Valoarea nu poate fi negativă</small>-->
                                                        <!--                                                            </b-form-group>-->
                                                        <!--                                                        </validation-provider>-->
                                                        <!--                                                        <validation-provider-->
                                                        <!--                                                            #default="{ errors }"-->
                                                        <!--                                                            rules="required"-->
                                                        <!--                                                            class=""-->
                                                        <!--                                                            style="width: 49%"-->
                                                        <!--                                                        >-->
                                                        <!--                                                            <b-form-group label="Procentul care contribuie la obiectivele de mediu">-->
                                                        <!--                                                                <b-form-input-->
                                                        <!--                                                                    v-model="processedContributionPercentage"-->
                                                        <!--                                                                    type="number"-->
                                                        <!--                                                                    step=".01"-->
                                                        <!--                                                                    :state="errors.length > 0 ? false : null"-->
                                                        <!--                                                                    readonly-->
                                                        <!--                                                                    @change="calculateContributionPercent()"-->
                                                        <!--                                                                ></b-form-input>-->
                                                        <!--                                                                <img v-if="!errors[0]" src="@/assets/images/checkMark.png"-->
                                                        <!--                                                                     class="checkMark"-->
                                                        <!--                                                                >-->
                                                        <!--                                                                <small class="text-danger">{{ errors[0] }}</small>-->
                                                        <!--                                                            </b-form-group>-->
                                                        <!--                                                        </validation-provider>-->
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            :rules="{ required: true, regex: /^0|100$/ }"
                                                            class="noMarginMobile"
                                                            style="width: 100%"
                                                            name="contribuția cheltuielii la obiectivele de mediu"
                                                        >
                                                            <b-form-group>
                                                                <!--                                                                <b-form-input-->
                                                                <!--                                                                    v-model="processedContributionTotal"-->
                                                                <!--                                                                    step=".01" type="number"-->
                                                                <!--                                                                    :state="errors.length > 0 ? false : null"-->
                                                                <!--                                                                    :class="negativeNumbers.contribution_total ? 'is-invalid' : ''"-->
                                                                <!--                                                                    @change="calculateContributionValue()"-->
                                                                <!--                                                                ></b-form-input>-->
                                                                <!--                                                                <img v-if="!errors[0] && !negativeNumbers.contribution_total"-->
                                                                <!--                                                                     src="@/assets/images/checkMark.png" class="checkMark"-->
                                                                <!--                                                                >-->
                                                                <!--                                                                <small class="text-danger">{{ errors[0] }}</small>-->
                                                                <!--                                                                <small v-if="negativeNumbers.contribution_total"-->
                                                                <!--                                                                       class="text-danger"-->
                                                                <!--                                                                >Valoarea nu poate fi negativă</small>-->
                                                                <b-form-radio-group
                                                                    id="btn-radios"
                                                                    v-model="form.subcategories.acquisitions.contribution_percentage"
                                                                    :options="[
                                                                        { text: 'Achiziție verde', value: 100 },
                                                                        { text: 'Nu contribuie la obiectivele de mediu', value: 0 },
                                                                    ]"
                                                                    button-variant="outline-primary"
                                                                    buttons
                                                                    class="mediuRadio noMarginMobile"
                                                                    name="radio-btn-outline"
                                                                    style="width: 100%"
                                                                    @change="calculateContributionPercent()"
                                                                ></b-form-radio-group>
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="inputs-group flex years-wrapper">
                                                    <div class="col-md-12 flex mobile-column pl-0 mobilePl"
                                                         style="padding-right: 0;"
                                                    >

                                                        <div class="flex flex-column" style="width:100%; margin-top:20px">
                                                            <span class="white-text"><strong>Alege anul sau anii în care estimezi că vei efectua cheltuiala</strong></span>
                                                            <div class="flex space-between wrap-elements years-inner-wrapper">
                                                                <!--<b-form-group class="percent-input" label="Primul an">-->
                                                                <!--<b-form-input type="text"></b-form-input>-->
                                                                <!--<img src="@/assets/images/checkMark.png" class="checkMark">-->
                                                                <!--</b-form-group>-->
                                                                <!--<b-form-group class="percent-input" label="Al doilea an">-->
                                                                <!--<b-form-input type="text"></b-form-input>-->
                                                                <!--<img src="@/assets/images/checkMark.png" class="checkMark">-->
                                                                <!--</b-form-group>-->
                                                                <div style="width: 49%">
                                                                    <b-form-group v-slot="{ ariaDescribedby }" label="Selectează anul">
                                                                        <b-form-checkbox-group
                                                                            id="btn-radios-2"
                                                                            v-model="contributionYears"
                                                                            :options="[2022, 2023]"
                                                                            :aria-describedby="ariaDescribedby"
                                                                            button-variant="outline-primary"
                                                                            size="lg"
                                                                            name="radio-btn-outline"
                                                                            class="radio-buttons-years w-100 select-year-wrapper"
                                                                            buttons
                                                                            multiselect
                                                                            @change="getContributionYears(contributionYears)"
                                                                        ></b-form-checkbox-group>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="flex space-between percent-inputs-wrapper" style="width:49% ; gap:10px">
                                                                    <validation-provider
                                                                        #default="{ errors }"
                                                                        rules="required"
                                                                        class="percent-input"
                                                                        style="margin-top: 0 !important;"
                                                                    >
                                                                        <b-form-group label="Procent an 2022">
                                                                            <b-form-input
                                                                                v-model="form.subcategories.acquisitions.first_year_percentage"
                                                                                type="number"
                                                                                step="0.01"
                                                                                :state="errors.length > 0 ? false : null"
                                                                                :class="negativeNumbers.first_year_percentage ? 'is-invalid' : ''"
                                                                                @change="changePercentage('first')"
                                                                            ></b-form-input>
                                                                            <img
                                                                                v-if="!errors[0] && !negativeNumbers.first_year_percentage"
                                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                                            >
                                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                                            <small v-if="negativeNumbers.first_year_percentage"
                                                                                   class="text-danger"
                                                                            >Valoarea nu poate fi
                                                                                negativă</small>
                                                                        </b-form-group>
                                                                    </validation-provider>
                                                                    <validation-provider
                                                                        #default="{ errors }"
                                                                        rules="required"
                                                                        class="percent-input"
                                                                        style="margin-top: 0 !important;"
                                                                    >
                                                                        <b-form-group label="Procent an 2023">
                                                                            <b-form-input
                                                                                v-model="form.subcategories.acquisitions.second_year_percentage"
                                                                                type="number"
                                                                                :state="errors.length > 0 ? false : null"
                                                                                :class="negativeNumbers.second_year_percentage ? 'is-invalid' : ''"
                                                                                @change="changePercentage('second')"
                                                                            ></b-form-input>
                                                                            <img
                                                                                v-if="!errors[0] && !negativeNumbers.second_year_percentage"
                                                                                src="@/assets/images/checkMark.png" class="checkMark"
                                                                            >
                                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                                            <small v-if="negativeNumbers.second_year_percentage"
                                                                                   class="text-danger"
                                                                            >Valoarea nu poate fi
                                                                                negativă</small>
                                                                        </b-form-group>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--<div class="flex align-center text-align-right ml-3">-->
                                                        <!--<span class="white-text" style="max-width: 100px;"><strong>Obiectivele de mediu</strong></span>-->
                                                        <!--<div class="chart x-20 m-0" style="&#45;&#45;value: 50%;">-->
                                                        <!--<p>80%</p>-->
                                                        <!--</div>-->
                                                        <!--</div>-->
                                                    </div>
                                                </div>
                                            </div>

                                            <!--                                        <div class="ml-3 white-background">-->
                                            <!--                                            <div class="black-title align-items-start mt-3 mb-2">Informații suplimentare despre <strong>&nbsp;achiziție</strong></div>-->
                                            <!--                                            <div class="bottom-row-inputs flex black-color">-->
                                            <!--                                                <b-form-checkbox-->
                                            <!--                                                    v-model="form.subcategories.acquisitions.represent_equipment"-->
                                            <!--                                                    size="xl"-->
                                            <!--                                                    class="checkbox"-->
                                            <!--                                                >Cheltuiala reprezintă un echipament și contribuie la criteriul de departajare<br><strong>“ponderea echipamentului tehnologic din valoarea totală a proiectului”</strong></b-form-checkbox>-->
                                            <!--                                            </div>-->
                                            <!--                                        </div>-->
                                            <div class="w-60 smis-hub-button-wrapper mobilePl marginSmallMobile">
                                                <div class="smis-hub-button" @click="toggleSmisHub()">
                                                    <div class="mr-4">
                                                        <p class="m-0">Nu ai un furnizor pentru un echipament/produs?</p>
                                                        <p class="m-0"><strong>Avem noi!</strong> Primești una / două oferte
                                                            în <strong>maxim 48h</strong></p>
                                                        <p class="m-0">Vreau să primesc ofertă/e personalizate.</p>
                                                    </div>
                                                    <img src="@/assets/images/M3/M3Sketch/smis-hub-logo.svg" alt="" class="smis-hub-vector">
                                                </div>
                                                <!--                                            <div v-if="smisHubError" class="smis-hub-error mt-2">-->
                                                <!--                                                <img src="@/assets/images/M3/M3Sketch/warn.png" alt="">-->
                                                <!--                                                <p>Funcția Smis HUB este disponibilă exclusiv utilizatorilor licențiați.</p>-->
                                                <!--                                            </div>-->
                                            </div>
                                        </div>
                                        <span class="title align-items-start mt-3 mb-2 smallMobilePl">Adăugarea celor două oferte <strong>&nbsp;pentru fundamentarea costurilor</strong></span>
                                        <div class="inputs-group flex flex-end space-between upload-files-wrapper">
                                            <div class="col-md-6 flex smallMobilePl" style="max-width: 538px; padding-right: 0;">
                                                <div class="flex upload-files-inner" style="max-width: 600px; width: 100%;">
                                                    <div class="medium-large-input">
                                                        <img v-if="offer_1_error" src="@/assets/images/M3/M3Sketch/warn.png" alt="Warning"><span style="color: red">{{ offer_1_error }}</span>
                                                        <b-form-group
                                                            label="Oferta 1"
                                                            class="group"
                                                        >
                                                            <b-form-file
                                                                ref="offer_1"
                                                                name="image"
                                                                accept=".jpg, .png, .gif, .pdf"
                                                                :placeholder="form.subcategories.acquisitions.offer_1.filename ? form.subcategories.acquisitions.offer_1.filename : 'Nu ai ales un fișier'"
                                                                @change="handleOffer($event,1)"
                                                            ></b-form-file>
                                                        </b-form-group>

                                                        <b-form-group label="Număr de înregistrare ofertă 1">
                                                            <b-form-input
                                                                v-model="form.subcategories.acquisitions.offer_1_reg_no"
                                                                type="text"
                                                            ></b-form-input>
                                                            <img src="@/assets/images/checkMark.png" class="checkMark">
                                                        </b-form-group>
                                                    </div>
                                                    <div v-if="form.subcategories.acquisitions.offer_1.filename"
                                                         class="flex offerIcons"
                                                    >
                                                        <b-icon-eye v-if="!documentsChanged.includes(1)"
                                                                    style="margin-right: 4px; cursor: pointer;"
                                                                    @click="viewOffer(form.subcategories.acquisitions.offer_1)"
                                                        ></b-icon-eye>
                                                        <b-icon-trash style="cursor: pointer"
                                                                      @click="deleteOffer(form.subcategories.acquisitions.offer_1, 1)"
                                                        ></b-icon-trash>
                                                    </div>
                                                </div>
                                                <div class="flex upload-files-inner" style="max-width: 600px; width: 100%;">
                                                    <div class="medium-large-input">
                                                        <img v-if="offer_2_error" src="@/assets/images/M3/M3Sketch/warn.png" alt="Warning"><span style="color: red">{{ offer_2_error }}</span>
                                                        <b-form-group
                                                            label="Oferta 2"
                                                            class="group"
                                                        >
                                                            <b-form-file
                                                                ref="offer_2"
                                                                name="image"
                                                                accept=".jpg, .png, .gif, .pdf"
                                                                :placeholder="form.subcategories.acquisitions.offer_2.filename ? form.subcategories.acquisitions.offer_2.filename : 'Nu ai ales un fișier'"
                                                                @change="handleOffer($event,2)"
                                                            ></b-form-file>
                                                        </b-form-group>
                                                        <b-form-group label="Număr de înregistrare ofertă 2">
                                                            <b-form-input
                                                                v-model="form.subcategories.acquisitions.offer_2_reg_no"
                                                                type="text"
                                                            ></b-form-input>
                                                            <img src="@/assets/images/checkMark.png" class="checkMark">
                                                        </b-form-group>
                                                    </div>
                                                    <div v-if="form.subcategories.acquisitions.offer_2.filename"
                                                         class="flex offerIcons"
                                                    >
                                                        <b-icon-eye v-if="!documentsChanged.includes(2)"
                                                                    style="margin-right: 4px; cursor: pointer;"
                                                                    @click="viewOffer(form.subcategories.acquisitions.offer_2)"
                                                        ></b-icon-eye>
                                                        <b-icon-trash style="cursor: pointer"
                                                                      @click="deleteOffer(form.subcategories.acquisitions.offer_2, 2)"
                                                        ></b-icon-trash>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="flex space-between margin-mobile-top mobileWrap" style="max-width: 540px; width: 100%;">
                                                <div>
                                                    <b-button class="blue-button" @click="openReperModal()">
                                                        <strong>Salvează reperul</strong>
                                                        <img v-if="form.subcategories.acquisitions.description &&
                                                                 form.subcategories.acquisitions.justificare"
                                                             src="@/assets/images/M3/M3Sketch/check-mark.png"
                                                             class="check-mark-reper" alt=""
                                                        >
                                                        <img v-else src="@/assets/images/M3/M3Sketch/warn.png" class="checkMark"
                                                             alt=""
                                                        >
                                                    </b-button>
                                                    <a href="/documents/Sablon_SMIS.docx" style="color: white; font-size: 13px; margin-top: 10px" download="Șablon SMIS.docx">Descarcă șablon ofertă pentru repere</a>
                                                </div>
                                                <b-button class="black-button"
                                                          :disabled="negativeNumbers.eligible || negativeNumbers.pret_unitar_cu_tva ||
                                                              negativeNumbers.pret_unitar_fara_tva || negativeNumbers.cantitate ||
                                                              negativeNumbers.cota_tva || negativeNumbers.neeligible ||
                                                              negativeNumbers.contribution_total || negativeNumbers.first_year_percentage ||
                                                              negativeNumbers.second_year_percentage || disableButton"
                                                          @click="saveForm($event)"
                                                >
                                                    <strong>Salvează cheltuiala</strong>
                                                    <img v-if="form.subcategories.acquisitions.description &&
                                                             form.category_no &&
                                                             form.subcategories.subcategory_no &&
                                                             form.subcategories.acquisitions.justificare &&
                                                             unitPriceWithoutVat && !negativeNumbers.eligible && !negativeNumbers.pret_unitar_cu_tva &&
                                                             !negativeNumbers.pret_unitar_fara_tva && !negativeNumbers.cantitate &&
                                                             !negativeNumbers.cota_tva && !negativeNumbers.neeligible &&
                                                             !negativeNumbers.contribution_total && !negativeNumbers.first_year_percentage &&
                                                             !negativeNumbers.second_year_percentage"
                                                         src="@/assets/images/checkMark.png" class="checkMark" alt=""
                                                    >
                                                    <img v-else src="@/assets/images/M3/M3Sketch/warn.png" class="checkMark"
                                                         alt=""
                                                    >
                                                </b-button>
                                                <ReperModal
                                                    :spending="form"
                                                    :files="{
                                                        file1: file1,
                                                        file2: file2
                                                    }"
                                                    :repereModal="reperModal"
                                                    @hideTempModal="reperModal = false"
                                                    @saveSpending="getUserSpendings()"
                                                    @updateFiles="updateFiles($event)"
                                                ></ReperModal>
                                            </div>
                                        </div>
                                    </div>
                                </b-form>
                            </validation-observer>
                            <SmisHub v-if="smisHub" :is-paid="paidCompany" :data="smisHubData" :justificare="form.subcategories.acquisitions.justificare" :descriere="form.subcategories.acquisitions.description" :price="form.subcategories.acquisitions.pret_unitar_cu_tva"></SmisHub>
                        </div>
                    </div>
                </b-overlay>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import {
        BModal,
        BForm,
        BFormGroup,
        BIconX,
        BIconXCircleFill,
        BFormInput,
        BFormCheckboxGroup,
        BButton,
        BIconTrash,
        BIconEye,
        BFormTextarea,
        BFormFile,
        BIconUpload,
        BIconSearch,
        BFormCheckbox,
        BOverlay,
        BFormRadioGroup,
        BCollapse,
        BIconArrowRight,
        BIconArrowDown,
        BSpinner
    } from 'bootstrap-vue';
    import vSelect from 'vue-select'
    /*import cpvJson from '../achizitii-cheltuieli/cpv.json'*/
    import ReferenceProduct from './components/ReferenceProduct'
    import ReperModal from './components/ReperModal'
    import SmisHub from './components/SmisHub'
    import categoriiAchizitiiJson from '../achizitii-cheltuieli/categoriiAchizitii.json'
    import _ from "lodash";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import {ValidationProvider, ValidationObserver} from 'vee-validate'

    require('@/helpers/validations/validations')

    export default {
        components: {
            BModal,
            BForm,
            BSpinner,
            BFormGroup,
            BFormInput,
            BFormCheckboxGroup,
            BButton,
            ReferenceProduct,
            ReperModal,
            SmisHub,
            BIconTrash,
            BIconEye,
            BIconX,
            BIconXCircleFill,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            BIconSearch,
            BOverlay,
            BFormCheckbox,
            BFormRadioGroup,
            BCollapse,
            BIconArrowRight,
            BIconArrowDown,
            vSelect,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            achizitiiModal: {
                type: Boolean,
                default: false
            },
            edit: {
                categoryId: null,
                subcategoryId: null,
                acquisitionId: null
            },
            reset: null
        },
        data() {
            return {
                /* LOADING */
                acquisitionLoading: false,
                opacity: 0.90,
                loadingText: 'Adăugăm achiziția în proiectul tău. Te rugăm să aștepți câteva momente.',
                selectedContribution: null,
                reperModal: false,
                smisHubData: null,
                categoryNoError: false,
                subcategoryNoError: false,
                smisHub: false,
                smisHubError: false,
                eligibleProduct: true,
                documentsChanged: [],
                productFromRefferences: false,
                userVisible: true,
                searchQuery: '',
                unitPriceWithoutVat: null,
                unitPriceWithVat: null,
                eligibleTVAmore: false,
                eligibileNoTVAmore: false,
                processedEligible: 0,
                processedNeeligible: 0,
                processedContributionPercentage: 0,
                processedContributionTotal: 0,
                negativeNumbers: {
                    eligible: null,
                    pret_unitar_cu_tva: null,
                    pret_unitar_fara_tva: null,
                    cantitate: null,
                    cota_tva: null,
                    neeligible: null,
                    contribution_total: null,
                    first_year_percentage: null,
                    second_year_percentage: null,
                },
                form: {
                    category_no: null,
                    subcategories: {
                        subcategory_no: null,
                        acquisitions: {
                            acquisitionId: null,
                            description: '',
                            justificare: '',
                            pret_unitar_cu_tva: 0,
                            pret_unitar_fara_tva: 0,
                            cantitate: 1,
                            um: 'buc',
                            cota_tva: 19,
                            eligible: 0,
                            neeligible: 0,
                            total: 0, // Total fara TVA
                            total_cu_tva: 0,
                            // activitatea_proiectului: '',
                            // subactivitatea_proiectului: '',
                            contribution_percentage: 0,
                            contribution_total: 0,
                            first_year_percentage: 100,
                            second_year_percentage: 0,
                            represent_equipment: false,
                            offer_1: {
                                id: null,
                                filename: null
                            },
                            offer_2: {
                                id: null,
                                filename: null
                            },
                            env_contr: {
                                id: null,
                                filename: null
                            },
                            offer_1_reg_no: '',
                            offer_2_reg_no: '',
                            tip_contract: '',
                            cpv: ''
                        }
                    }
                },
                disableButton: false,
                contributionYears: [],
                file1: null,
                file2: null,
                listareProduse: [],
                userSpendings: [],
                /*listaCpv: cpvJson,*/
                timer: null,
                selectedAchizitie: null,
                index: null,
                editabledAcquisition: null,
                references: [],
                deleteOfferAction: null,
                copySpendings: null,
                offer_1_error: '',
                offer_2_error: '',
                acceptedFiles: [
                    'image/png',
                    'image/jpg',
                    'image/jpeg',
                    'application/pdf'
                ],
                paidCompany: false,
                allSpendings: [],
                productsSearched: []
            };
        },

        computed: {
            openModalShow: {
                get() {
                    return this.achizitiiModal
                },
                set(achizitiiModal) {
                    return achizitiiModal
                }
            },

            allData() {
                return this.$store.getters['m3Sketch/allData']
            },

            getCategories() {
                return categoriiAchizitiiJson.map(item => {
                    return {id: item.id, name: item.id + ' ' + item.name}
                });
            },

            getSpendingsLength() {
                let number = 0
                this.listareProduse.forEach(category => {
                    number += category.spendings.length
                })
                return number
            },

            getSubcategories() {
                return this.form.category_no ? categoriiAchizitiiJson.find(item => {
                    return item.id == this.form.category_no
                }).subcategories.map(subcategory => {
                    if(! subcategory.name.startsWith(subcategory.id)) {
                        subcategory.name = subcategory.id + ' ' + subcategory.name;
                    }

                    return subcategory
                }) : [];
            },

            // getActivities() {
            //     return this.allData && this.allData.m3_project && this.allData.m3_project.activities && this.allData.m3_project.activities.activities.length ?
            //         this.allData.m3_project.activities.activities.map(function (activitate) {
            //             return {
            //                 'name': activitate.number + '. ' + activitate.title,
            //                 'childrens': activitate.childrens,
            //                 'id': activitate.id,
            //             }
            //         }) : []
            // },

            // getSubactivities() {
            //     if (!this.form.subcategories.acquisitions.activitatea_proiectului)
            //         return [];
            //
            //     let activity = []
            //     if (this.allData && this.allData.m3_project && this.allData.m3_project.activities && this.allData.m3_project.activities.activities.length) {
            //         activity = this.allData.m3_project.activities.activities.find(
            //             (activity) => {
            //                 return activity.id == this.form.subcategories.acquisitions.activitatea_proiectului
            //             }
            //         )
            //     }
            //
            //
            //     if (activity)
            //         return activity.childrens.map(function (subactivitate) {
            //             return {
            //                 'name': (activity ? activity.number : '') + '. ' + (subactivitate ? subactivitate.number : '') + '. ' + (subactivitate ? subactivitate.title : ''),
            //                 'id': subactivitate ? subactivitate.id : 0,
            //             }
            //         })
            //     else
            //         return [];
            // },

            getContractTypes() {
                return [
                    {
                        name: 'Furnizare'
                    },
                    {
                        name: 'Lucrări'
                    },
                    {
                        name: 'Servicii'
                    }
                ]
            },

        /*getCpvCodes() {
            return this.listaCpv.map((cpv) => {
                return {
                    id: cpv.Cod_CPV,
                    label: cpv.Cod_CPV + ' - ' + cpv.Cod_CPV_descriere
                }
            })
        }*/
        },

        watch: {
            'reset': function (value) {
                if (value) this.resetFields();
            },
            documentsChanged: {
                handler: function() {
                    if(this.form.subcategories.acquisitions.fromSpendings && this.documentsChanged.length === 2) {
                        this.form.subcategories.acquisitions.fromSpendings = false;
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.paidCompany = JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).paid : null
            if (this.edit.categoryId !== null && this.edit.subcategoryId !== null && this.edit.acquisitionId !== null) {
                this.editabledAcquisition = this.allData.m3_project.spendings[this.edit.categoryId];

                this.form.category_no = this.editabledAcquisition.category_no;

                this.editabledAcquisition = this.editabledAcquisition.subcategories[this.edit.subcategoryId];

                this.form.subcategories.subcategory_no = this.editabledAcquisition.subcategory_no;

                this.form.subcategories.acquisitions = this.editabledAcquisition.acquisitions[this.edit.acquisitionId]
                if (this.form.subcategories.acquisitions) {
                    this.unitPriceWithoutVat = parseFloat(this.form.subcategories.acquisitions.pret_unitar_fara_tva).toFixed(2);
                    this.unitPriceWithVat = parseFloat(this.form.subcategories.acquisitions.pret_unitar_cu_tva).toFixed(2);
                }

                this.index = this.edit.acquisitionId;
                this.processedContributionTotal = parseFloat(this.form.subcategories.acquisitions.contribution_total).toFixed(2);
                this.processedContributionPercentage = parseFloat(this.form.subcategories.acquisitions.contribution_percentage).toFixed(2);
                if(Number(this.form.subcategories.acquisitions.contribution_percentage) === 100)
                    this.selectedContribution = 100;
                else
                    this.selectedContribution = 0;
                this.processedNeeligible = parseFloat(this.form.subcategories.acquisitions.neeligible).toFixed(2);
                this.processedEligible = parseFloat(this.form.subcategories.acquisitions.eligible).toFixed(2);
            }

            if (this.form.subcategories.acquisitions.first_year_percentage) {
                this.contributionYears.push(2022)
            }

            if (this.form.subcategories.acquisitions.second_year_percentage) {
                this.contributionYears.push(2023)
            }

            this.getReferences()
            this.getUserSpendings()

            this.smisHubData = {
                business_name: this.allData ? this.allData.name : '',
                name: this.$store.getters['auth/user'].name,
                email: this.$store.getters['auth/user'].email,
                phone: this.$store.getters['auth/user'].phone ? this.$store.state.auth.user.phone : '',
            }
        },
        methods: {
            limitCharacters() {
                if(this.form.subcategories.acquisitions.justificare.length > 300) {
                    this.form.subcategories.acquisitions.justificare = this.form.subcategories.acquisitions.justificare.substring(0,300)
                    this.$toast.error('Numărul maxim de caractere este de 300.')
                }
            },
            getClassBySpending(spending) {
                if(Number(spending.contribution_percentage) !== 100 && spending.eligible) {
                    return 'gray-label'
                } else if(!spending.eligible) {
                    return 'red-label'
                }
            },
            openReperModal() {
                if (!this.form.subcategories.acquisitions.description || !this.form.subcategories.acquisitions.justificare) {
                    this.$toast.error('Descrierea și justificarea sunt câmpuri obligatorii!');
                    return;
                }
                this.reperModal = true
            },
            getReferences() {
                axios.get(api.API_ENDPOINTS.references)
                    .then(response => {
                        this.references = response.data
                        this.allSpendings = []
                        response.data.forEach(category => {
                            category.spendings.forEach(item => {
                                this.allSpendings.push(item)
                            })

                        })
                        this.listareProduse = response.data
                    })
            },
            getUserSpendings() {
                axios.get(api.API_ENDPOINTS.m3UserSpendings)
                    .then(response => {
                        this.userSpendings = response.data
                    })
            },
            updateFiles(userSpending) {
                this.file1 = null;
                this.file2 = null;
                this.form.subcategories.acquisitions.offer_1.id = userSpending.offer_1 ? userSpending.offer_1.id : null;
                this.form.subcategories.acquisitions.offer_1.filename = userSpending.offer_1 ? userSpending.offer_1.filename : null;
                this.form.subcategories.acquisitions.offer_1_reg_no = userSpending.offer_1 ? userSpending.offer_1_reg_no : null;
                this.form.subcategories.acquisitions.offer_2.id = userSpending.offer_2 ? userSpending.offer_2.id : null;
                this.form.subcategories.acquisitions.offer_2.filename = userSpending.offer_2 ? userSpending.offer_2.filename : null;
                this.form.subcategories.acquisitions.offer_2_reg_no = userSpending.offer_2 ? userSpending.offer_2_reg_no : null;
            },
            selectUserSpending(key) {
                this.resetFields();
                let selectedSpending = this.userSpendings[key];
                this.form.category_no = selectedSpending.category_no;
                this.form.subcategories.subcategory_no = selectedSpending.subcategory_no;

                this.form.subcategories.acquisitions.description = selectedSpending.description;
                this.form.subcategories.acquisitions.justificare = selectedSpending.justification;
                this.form.subcategories.acquisitions.tip_contract = selectedSpending.contract_type;
                this.form.subcategories.acquisitions.cota_tva = selectedSpending.vat;
                this.form.subcategories.acquisitions.cpv = selectedSpending.cpv;
                this.form.subcategories.acquisitions.contribution_percentage = selectedSpending.contribution_percentage;
                if(Number(this.form.subcategories.acquisitions.contribution_percentage) === 100)
                    this.selectedContribution = 100
                else
                    this.selectedContribution = 0;
                this.form.subcategories.acquisitions.first_year_percentage = selectedSpending.first_year_percentage;
                this.form.subcategories.acquisitions.second_year_percentage = selectedSpending.second_year_percentage;
                this.form.subcategories.acquisitions.activitatea_proiectului = selectedSpending.activity;
                this.form.subcategories.acquisitions.subactivitatea_proiectului = selectedSpending.subactivity;
                this.form.subcategories.acquisitions.um = selectedSpending.um;
                this.form.subcategories.acquisitions.cantitate = selectedSpending.qty;
                this.form.subcategories.acquisitions.offer_1.id = selectedSpending.offer_1 ? selectedSpending.offer_1.id : null;
                this.form.subcategories.acquisitions.offer_1.filename = selectedSpending.offer_1 ? selectedSpending.offer_1.filename : null;
                this.form.subcategories.acquisitions.offer_1_reg_no = selectedSpending.offer_1 ? selectedSpending.offer_1_reg_no : null;
                this.form.subcategories.acquisitions.offer_2.id = selectedSpending.offer_2 ? selectedSpending.offer_2.id : null;
                this.form.subcategories.acquisitions.offer_2.filename = selectedSpending.offer_2 ? selectedSpending.offer_2.filename : null;
                this.form.subcategories.acquisitions.offer_2_reg_no = selectedSpending.offer_2 ? selectedSpending.offer_2_reg_no : null;

                if (this.form.subcategories.acquisitions.first_year_percentage) {
                    this.contributionYears.push(2022)
                }

                if (this.form.subcategories.acquisitions.second_year_percentage) {
                    this.contributionYears.push(2023)
                }
            },
            deleteUserSpending(id) {
                if (!id) {
                    return;
                }

                axios.delete(api.API_ENDPOINTS.m3UserSpendings + '/' + id)
                    .then(response => {
                        this.$toast.success(response.data.message);
                        this.userSpendings = response.data.spendings
                    })
            },
            toggleSmisHub() {
                //if(this.allData.paid){
                this.smisHub = !this.smisHub;
                this.smisHubError = false
            // } else{
            //     this.smisHubError = true
            // }

            },
            deleteOffer(offer, id) {
                if (this.edit.acquisitionId == null && id == 1) {
                    this.form.subcategories.acquisitions.offer_1 = {
                        id: null,
                        filename: null
                    }
                    this.form.subcategories.acquisitions.offer_1_reg_no = null;

                    return;
                }

                if (this.edit.acquisitionId == null && id == 2) {
                    this.form.subcategories.acquisitions.offer_2 = {
                        id: null,
                        filename: null
                    }
                    this.form.subcategories.acquisitions.offer_2_reg_no = null;
                    return;
                }

                axios.delete(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/delete/file/m3-offers/' + offer.id)
                    .then((response) => {
                        this.$toast.success(response.data.message);
                        if (this.form.subcategories.acquisitions.offer_1.id === offer.id) {
                            this.form.subcategories.acquisitions.offer_1 = {
                                id: null,
                                filename: null
                            }
                            this.form.subcategories.acquisitions.offer_1_reg_no = null;
                        } else {
                            this.form.subcategories.acquisitions.offer_2 = {
                                id: null,
                                filename: null
                            }
                            this.form.subcategories.acquisitions.offer_2_reg_no = null;
                        }
                        this.deleteOfferAction = true;
                        this.saveForm(true)
                    });

            },
            viewOffer(offer) {
                if(this.form.subcategories.acquisitions.fromSpendings && !this.paidCompany) {
                    this.$swal({
                        title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                        icon: 'info',
                        confirmButtonText: 'Cumpără licență',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$router.push({name: 'M3SketchCumparaLicenta'});
                        }
                    })
                } else {
                    if (offer.id !== null) {
                        location.href = api.API_ROOT + api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +
                            '/get/file/' + this.getOfferPath(offer.id)  + offer.id; // If doesn't work ask Istina
                    } else if (offer.default) {
                        location.href = api.API_ROOT + api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +
                            '/get/default_offer/' + offer.default;
                    } else {
                        return false;
                    }
                }
            },
            getOfferPath(id){
                let location = 'm3-offers/'

                this.userSpendings.forEach(reference => {
                    if(reference.offer_1 && reference.offer_1.id === id)
                        location = 'first_offer/'
                    if(reference.offer_2 && reference.offer_2.id === id)
                        location = 'second_offer/'
                })

                return location;
            },
            formatter(value) {
                if (value < 0)
                    return (value * (-1));
            },
            toFixed(value) {
                return value.toFixed(2)
            },
            searchAndGetAchizitii(text) {
                this.userVisible = false
                this.productsSearched = _.cloneDeep(_.filter(this.allSpendings, item => {
                    return item ? _.includes(item.description ? item.description.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '', text ? text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '') : '';
                }));
                if(text.length < 1){
                    this.productsSearched = []
                }
            },
            addProduct(productId) {
                this.resetFields()
                let selectedProduct = _.cloneDeep(_.filter(this.allSpendings, v => Number(v.id) === Number(productId))[0])
                this.eligibleProduct = selectedProduct.eligible
                this.form.subcategories.acquisitions.description = selectedProduct.description;
                this.form.subcategories.acquisitions.justificare = selectedProduct.justificare;
                this.form.subcategories.acquisitions.cantitate = selectedProduct.cantitate;
                this.form.subcategories.acquisitions.um = selectedProduct.um;
                this.form.subcategories.acquisitions.first_year_percentage = selectedProduct.first_year_percentage;
                this.form.subcategories.acquisitions.second_year_percentage = selectedProduct.second_year_percentage;
                this.form.subcategories.acquisitions.tip_contract = selectedProduct.tip_contract;
                this.form.subcategories.acquisitions.cpv = selectedProduct.cpv;
                this.form.subcategories.acquisitions.offer_1 = selectedProduct.offer_1;
                this.form.subcategories.acquisitions.offer_2 = selectedProduct.offer_2;
                this.form.subcategories.acquisitions.offer_1_reg_no = selectedProduct.offer_1_reg_no;
                this.form.subcategories.acquisitions.offer_2_reg_no = selectedProduct.offer_2_reg_no;
                this.form.subcategories.acquisitions.fromSpendings = true;
                this.form.category_no = selectedProduct.category_no;
                this.form.subcategories.subcategory_no = selectedProduct.subcategory_no;
                // this.form.subcategories.acquisitions.represent_equipment = selectedProduct.is_equipment;
                this.documentsChanged = []
                this.loadingText = 'Generăm cele două oferte de preț pentru compania ta, te rugăm să aștepți finalizarea. Îți mulțumim!'

                if (selectedProduct.unit_price_include_vat) {
                    this.unitPriceWithVat = parseFloat(selectedProduct.unit_price).toFixed(2);
                    this.valueChangedForUnitPriceWithVat()
                } else {
                    this.form.subcategories.acquisitions.pret_unitar_fara_tva = parseFloat(selectedProduct.unit_price);
                    this.unitPriceWithoutVat = parseFloat(selectedProduct.unit_price).toFixed(2);
                    this.valueChangedForUnitPriceWithoutVat()
                }

                // this.processedContributionTotal = 0;
                // this.processedContributionPercentage = parseFloat(selectedProduct.contribution_percentage).toFixed(2);
                this.form.subcategories.acquisitions.contribution_percentage = parseFloat(selectedProduct.contribution_percentage)
                this.calculateContributionPercent();

                if(selectedProduct.first_year_percentage > 0) {
                    this.contributionYears.push(2022)
                }
                if (selectedProduct.second_year_percentage > 0) {
                    this.contributionYears.push(2023)
                }
            },
            activityChanged() {
                this.form.subcategories.acquisitions.subactivitatea_proiectului = ''
            },
            categoryChanged() {
                this.form.subcategories.subcategory_no = ''
                this.categoryNoError = false
                this.calculateFaraTVA();
            },
            calculateFaraTVA() {
                this.form.subcategories.acquisitions.total =
                    this.form.subcategories.acquisitions.cantitate ?
                        Number(this.form.subcategories.acquisitions.cantitate) *
                        Number(this.form.subcategories.acquisitions.pret_unitar_fara_tva)
                        : ''
                this.form.subcategories.acquisitions.total_cu_tva =
                    this.form.subcategories.acquisitions.cota_tva ?
                        Number(this.form.subcategories.acquisitions.total) *
                        ((Number(this.form.subcategories.acquisitions.cota_tva) / 100)) +
                        Number(this.form.subcategories.acquisitions.total)
                        : 0
                this.form.subcategories.acquisitions.pret_unitar_cu_tva =
                    this.form.subcategories.acquisitions.cota_tva ?
                        Number(this.form.subcategories.acquisitions.pret_unitar_fara_tva) +
                        (Number(this.form.subcategories.acquisitions.pret_unitar_fara_tva) *
                            (Number(this.form.subcategories.acquisitions.cota_tva) / 100))
                        : ''

                if (this.form.category_no != 5 && this.eligibleProduct) {
                    let total = this.allData && this.allData.vat_status == 'PLATITOR' ? this.form.subcategories.acquisitions.total : this.form.subcategories.acquisitions.total_cu_tva;
                    this.form.subcategories.acquisitions.eligible = total;
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva - this.form.subcategories.acquisitions.eligible;
                } else {
                    this.form.subcategories.acquisitions.eligible = 0;
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva;
                }
                this.processedEligible = parseFloat(this.form.subcategories.acquisitions.eligible).toFixed(2);
                this.processedNeeligible = parseFloat(this.form.subcategories.acquisitions.neeligible).toFixed(2);

                this.calculateContributionPercent();
                this.checkInputsForNegativeValues();
            },
            calculateCuTVA() {
                this.form.subcategories.acquisitions.pret_unitar_fara_tva =
                    this.form.subcategories.acquisitions.pret_unitar_cu_tva ||
                    this.form.subcategories.acquisitions.cota_tva ?
                        Number(this.form.subcategories.acquisitions.pret_unitar_cu_tva) /
                        Number('1.' + this.form.subcategories.acquisitions.cota_tva)
                        : ''
                this.form.subcategories.acquisitions.total_cu_tva =
                    this.form.subcategories.acquisitions.cantitate ?
                        Number(this.form.subcategories.acquisitions.cantitate) *
                        Number(this.form.subcategories.acquisitions.pret_unitar_cu_tva)
                        : ''
                this.form.subcategories.acquisitions.total =
                    this.form.subcategories.acquisitions.cantitate ?
                        Number(this.form.subcategories.acquisitions.cantitate) *
                        Number(this.form.subcategories.acquisitions.pret_unitar_fara_tva)
                        : ''
                if (this.form.category_no != 5 && this.eligibleProduct) {
                    let total = this.allData && this.allData.vat_status == 'PLATITOR' ? this.form.subcategories.acquisitions.total : this.form.subcategories.acquisitions.total_cu_tva;
                    this.form.subcategories.acquisitions.eligible = total;
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva - this.form.subcategories.acquisitions.eligible;
                } else {
                    this.form.subcategories.acquisitions.eligible = 0;
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva;
                }
                this.processedEligible = parseFloat(this.form.subcategories.acquisitions.eligible).toFixed(2);
                this.processedNeeligible = parseFloat(this.form.subcategories.acquisitions.neeligible).toFixed(2);

                this.calculateContributionPercent();
                this.checkInputsForNegativeValues();
            },
            calculateOnChangeCotaTVA() {
                if(!this.form.subcategories.acquisitions.cota_tva) {
                    this.form.subcategories.acquisitions.cota_tva = 0
                } else if(this.form.subcategories.acquisitions.pret_unitar_cu_tva != '') {
                    this.calculateFaraTVA();
                    this.unitPriceWithVat = this.form.subcategories.acquisitions.pret_unitar_cu_tva
                }
            },
            calculateContributionPercent() {

                // this.form.subcategories.acquisitions.contribution_total = this.processedContributionTotal;
                // this.form.subcategories.acquisitions.contribution_percentage = this.processedContributionPercentage;

                if (Number(this.form.subcategories.acquisitions.contribution_percentage) > 100)
                    this.form.subcategories.acquisitions.contribution_percentage = 100

                this.form.subcategories.acquisitions.contribution_total =
                    (Number(this.form.subcategories.acquisitions.contribution_percentage) / 100) *
                    Number(this.form.subcategories.acquisitions.total_cu_tva)

                this.processedContributionTotal = parseFloat(this.form.subcategories.acquisitions.contribution_total).toFixed(2)
                this.processedContributionPercentage = parseFloat(this.form.subcategories.acquisitions.contribution_percentage).toFixed(2)

                this.checkInputsForNegativeValues();
            },
            calculateContributionValue() {

                this.form.subcategories.acquisitions.contribution_total = this.processedContributionTotal;
                this.form.subcategories.acquisitions.contribution_percentage = this.processedContributionPercentage;

                if (Number(this.form.subcategories.acquisitions.contribution_total) > Number(this.form.subcategories.acquisitions.total_cu_tva))
                    this.form.subcategories.acquisitions.contribution_total = Number(this.form.subcategories.acquisitions.total_cu_tva);

                this.form.subcategories.acquisitions.contribution_percentage =
                    (Number(this.form.subcategories.acquisitions.contribution_total) * 100) /
                    Number(this.form.subcategories.acquisitions.total_cu_tva)

                this.processedContributionTotal = parseFloat(this.form.subcategories.acquisitions.contribution_total).toFixed(2)
                this.processedContributionPercentage = parseFloat(this.form.subcategories.acquisitions.contribution_percentage).toFixed(2)

                this.checkInputsForNegativeValues();
            },
            getContributionYears(value) {
                if (value[0] === 2022 && value[1] === 2023 ||
                    value[0] === 2023 && value[1] === 2022) {
                    this.form.subcategories.acquisitions.first_year_percentage = 50
                    this.form.subcategories.acquisitions.second_year_percentage = 50
                } else {
                    if (value.includes(2022)) {
                        this.form.subcategories.acquisitions.first_year_percentage = 100
                    } else {
                        this.form.subcategories.acquisitions.first_year_percentage = 0
                    }
                    if (value.includes(2023)) {
                        this.form.subcategories.acquisitions.second_year_percentage = 100
                    } else {
                        this.form.subcategories.acquisitions.second_year_percentage = 0
                    }
                }
                this.checkInputsForNegativeValues();
            },
            changePercentage(year) {
                if (year === 'first') {
                    this.form.subcategories.acquisitions.first_year_percentage = parseFloat(this.form.subcategories.acquisitions.first_year_percentage).toFixed(0);
                    if (this.form.subcategories.acquisitions.first_year_percentage > 100)
                        this.form.subcategories.acquisitions.first_year_percentage = 100;
                    if (this.form.subcategories.acquisitions.first_year_percentage === '100') {
                        this.contributionYears = [2022]
                    } else {
                        this.contributionYears = [2022, 2023]
                    }

                    this.form.subcategories.acquisitions.second_year_percentage = 100 -
                        this.form.subcategories.acquisitions.first_year_percentage
                }
                if (year === 'second') {
                    this.form.subcategories.acquisitions.second_year_percentage = parseFloat(this.form.subcategories.acquisitions.second_year_percentage).toFixed(0);
                    if (this.form.subcategories.acquisitions.second_year_percentage > 100)
                        this.form.subcategories.acquisitions.second_year_percentage = 100;
                    if (this.form.subcategories.acquisitions.second_year_percentage === '100') {
                        this.contributionYears = [2023]
                    } else {
                        this.contributionYears = [2022, 2023]
                    }

                    this.form.subcategories.acquisitions.first_year_percentage = 100 -
                        this.form.subcategories.acquisitions.second_year_percentage
                }
                this.checkInputsForNegativeValues();
            },
            saveForm(event) {
                this.acquisitionLoading = true
                if (event !== true)
                    event.preventDefault()
                this.$refs.aquisitionForm.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        this.acquisitionLoading = false
                    } else {
                        if (event) {
                            let lastId = this.allData.m3_project.last_acquisition_id;
                            if(this.form.category_no < 1 || this.form.subcategories.subcategory_no < 1 || this.form.subcategories.subcategory_no === '0.0.') {
                                this.acquisitionLoading = false
                                if(this.form.category_no < 1) {
                                    this.categoryNoError = true
                                }
                                if(this.form.subcategories.subcategory_no < 1) {
                                    this.subcategoryNoError = true
                                }
                            } else {
                                this.disableButton = true;
                                let categoryNo = this.form.category_no
                                let subcategoryNo = this.form.subcategories.subcategory_no
                                let spendings
                                if (this.allData.m3_project) {
                                    spendings = this.allData.m3_project.spendings;

                                    // Check if category_no exists in database
                                    let getAchizitieWithCategoryExists = _.findIndex(spendings, {
                                        'category_no': categoryNo
                                    })
                                    let findAchizitieWithCategoryExists = _.find(spendings, {
                                        'category_no': categoryNo
                                    })

                                    let getAchizitieWithSubcategoryExists = false
                                    if (findAchizitieWithCategoryExists) {
                                        getAchizitieWithSubcategoryExists = _.findIndex(findAchizitieWithCategoryExists.subcategories, {
                                            'subcategory_no': subcategoryNo
                                        })
                                    }

                                    if(this.edit.acquisitionId === null){
                                        lastId++;
                                        this.form.subcategories.acquisitions.acquisitionId = lastId;
                                    }

                                    if (getAchizitieWithSubcategoryExists !== -1 &&
                                        getAchizitieWithCategoryExists !== -1) { // Exista categoria si subcategoria
                                        if (this.edit.acquisitionId !== null) {
                                            if (this.edit.categoryId !== (Number(this.form.category_no) - 1) || this.editabledAcquisition.subcategory_no !== this.form.subcategories.subcategory_no) {
                                                this.$delete(this.allData.m3_project.spendings[this.edit.categoryId].subcategories[this.edit.subcategoryId].acquisitions, this.edit.acquisitionId);
                                                this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories[getAchizitieWithSubcategoryExists].acquisitions.push(this.form.subcategories.acquisitions);
                                                this.edit.acquisitionId = null;
                                            } else {
                                                this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories[getAchizitieWithSubcategoryExists].acquisitions[this.edit.acquisitionId] = this.form.subcategories.acquisitions;
                                            }

                                        } else {
                                            this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories[getAchizitieWithSubcategoryExists].acquisitions.push(this.form.subcategories.acquisitions)
                                        }

                                    } else if (getAchizitieWithCategoryExists !== -1 &&
                                        findAchizitieWithCategoryExists !== 'undefined' &&
                                        getAchizitieWithSubcategoryExists) { // Exista categoria

                                        this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories.push(this.form.subcategories)
                                    }

                                }

                                let data = new FormData;
                                data.append('spendings', JSON.stringify(this.allData.m3_project.spendings))
                                if(this.edit.acquisitionId === null) {
                                    data.append('last_acquisition_id', lastId)
                                }

                                if (this.file1 || this.file2) {
                                    data = this.getFilesFormData(data)
                                }

                                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', data, {
                                    header: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }).then(() => {
                                    let acquisitionId = this.form.subcategories.acquisitions.acquisitionId;
                                    this.$store.dispatch('m3Sketch/initializeIndicators')
                                    this.$store.dispatch('m3Sketch/initializeAllData')
                                    this.acquisitionLoading = false
                                    this.$emit('addOrEditAchizitie', acquisitionId)
                                    if (!this.deleteOfferAction) {
                                        this.$toast.success('Cheltuiala / achiziția a fost adăugată și salvată');
                                        this.resetFields()
                                        this.$emit('hideTempModal')
                                    } else {
                                        this.deleteOfferAction = null;
                                    }
                                    this.disableButton = false;
                                }).catch((xhr) => {
                                    this.acquisitionLoading = false
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    if(xhr && xhr.response && xhr.response.data && xhr.response.data.message)
                                        this.$toast.error(xhr.response.data.message);
                                    this.disableButton = false;
                                    if (this.allData.m3_project) {
                                        spendings = this.allData.m3_project.spendings;

                                        // Check if category_no exists in database
                                        let getAchizitieWithCategoryExists = _.findIndex(spendings, {
                                            'category_no': categoryNo
                                        })
                                        let findAchizitieWithCategoryExists = _.find(spendings, {
                                            'category_no': categoryNo
                                        })

                                        let getAchizitieWithSubcategoryExists = false
                                        if (findAchizitieWithCategoryExists) {
                                            getAchizitieWithSubcategoryExists = _.findIndex(findAchizitieWithCategoryExists.subcategories, {
                                                'subcategory_no': subcategoryNo
                                            })
                                        }

                                        if (getAchizitieWithSubcategoryExists !== -1 &&
                                            getAchizitieWithCategoryExists !== -1) { // Exista categoria si subcategoria

                                            this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories[getAchizitieWithSubcategoryExists].acquisitions.pop()

                                        } else if (getAchizitieWithCategoryExists !== -1 &&
                                            findAchizitieWithCategoryExists !== 'undefined' &&
                                            getAchizitieWithSubcategoryExists) { // Exista categoria

                                            this.allData.m3_project.spendings[getAchizitieWithCategoryExists].subcategories.pop()
                                        } else { // Categorie Noua
                                            this.allData.m3_project.spendings.pop()
                                        }

                                    }
                                });
                            }
                        }
                    }
                })
            },
            checkTotalError() {
                this.form.subcategories.acquisitions.eligible = this.processedEligible;
                let total = this.allData && this.allData.vat_status == 'PLATITOR' ? this.form.subcategories.acquisitions.total : this.form.subcategories.acquisitions.total_cu_tva;
                this.eligibileNoTVAmore = this.form.subcategories.acquisitions.eligible > total;

                if (this.form.category_no != 6) {
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva - this.form.subcategories.acquisitions.eligible
                } else {
                    this.form.subcategories.acquisitions.neeligible = this.form.subcategories.acquisitions.total_cu_tva;
                }

                this.processedEligible = parseFloat(this.form.subcategories.acquisitions.eligible).toFixed(2);
                this.processedNeeligible = parseFloat(this.form.subcategories.acquisitions.neeligible).toFixed(2);
                this.checkInputsForNegativeValues();
            },
            calculateEligibleValues() {
                this.form.subcategories.acquisitions.neeligible = this.processedNeeligible;

                this.form.subcategories.acquisitions.eligible = this.form.subcategories.acquisitions.total_cu_tva - this.form.subcategories.acquisitions.neeligible

                this.processedEligible = parseFloat(this.form.subcategories.acquisitions.eligible).toFixed(2);
                this.processedNeeligible = parseFloat(this.form.subcategories.acquisitions.neeligible).toFixed(2);

                this.checkInputsForNegativeValues();
            },
            resetFields() {
                this.processedEligible = 0
                this.processedNeeligible = 0
                this.processedContributionTotal = 0
                this.processedContributionPercentage = 0
                this.selectedContribution = null
                this.eligibleProduct = true
                this.form = {
                    processedEligible: 0,
                    processedNeeligible: 0,
                    processedContributionPercentage: 0,
                    processedContributionTotal: 0,
                    category_no: null,
                    subcategories: {
                        subcategory_no: null,
                        acquisitions: {
                            acquisitionId: null,
                            description: '',
                            pret_unitar_cu_tva: 0,
                            pret_unitar_fara_tva: 0,
                            cantitate: 1,
                            um: 'buc',
                            cota_tva: 19,
                            total: 0, // Total fara TVA
                            total_cu_tva: 0,
                            activitatea_proiectului: '',
                            subactivitatea_proiectului: '',
                            contribution_percentage: 0,
                            contribution_total: 0,
                            first_year_percentage: 100,
                            second_year_percentage: 0,
                            offer_1: {
                                id: null,
                                filename: null
                            },
                            offer_2: {
                                id: null,
                                filename: null
                            },
                            env_contr: {
                                id: null,
                                filename: null
                            },
                            offer_1_reg_no: '',
                            offer_2_reg_no: '',
                            tip_contract: '',
                            cpv: ''
                        }
                    }
                }
                this.contributionYears = [];
                this.file1 = null;
                this.file2 = null;
                this.$refs.offer_1.reset();
                this.$refs.offer_2.reset();
                this.unitPriceWithVat = 0;
                this.unitPriceWithoutVat = 0;
                this.negativeNumbers = {
                    eligible: null,
                    pret_unitar_cu_tva: null,
                    pret_unitar_fara_tva: null,
                    cantitate: null,
                    cota_tva: null,
                    neeligible: null,
                    contribution_total: null,
                    first_year_percentage: null,
                    second_year_percentage: null,
                };
            },
            handleOffer(event, idx) {
                if( event && event.target && event.target.files && event.target.files.length ) {
                    if(!this.acceptedFiles.includes(event.target.files[0].type)){
                        if( idx === 1 ){
                            this.offer_1_error = 'Fișierele acceptate sunt de tip .pdf, .jpg, .png';
                            this.file1 = null;
                            this.form.subcategories.acquisitions.offer_1 = {filename: '', id: null};
                        }
                        else {
                            this.offer_2_error = 'Fișierele acceptate sunt de tip .pdf, .jpg, .png';
                            this.file2 = null;
                            this.form.subcategories.acquisitions.offer_2 = {filename: '', id: null};
                        }
                    } else {
                        if (idx === 1) {
                            this.file1 = event.target.files[0];
                            this.form.subcategories.acquisitions.offer_1.id = null;
                            this.form.subcategories.acquisitions.offer_1.filename = event.target.files[0].name;
                            this.offer_1_error = '';
                            if(this.form.subcategories.acquisitions.fromSpendings && !this.documentsChanged.includes(1)) {
                                this.documentsChanged.push(1)
                            }
                        } else {
                            this.file2 = event.target.files[0];
                            this.form.subcategories.acquisitions.offer_2.id = null;
                            this.form.subcategories.acquisitions.offer_2.filename = event.target.files[0].name;
                            this.offer_2_error = '';
                            if(this.form.subcategories.acquisitions.fromSpendings && !this.documentsChanged.includes(2)) {
                                this.documentsChanged.push(2)
                            }
                        }
                    }
                }
            },
            getFilesFormData(data) {
                data.append('index', this.index)
                data.append('category_no', this.form.category_no)
                data.append('subcategory_no', this.form.subcategories.subcategory_no)
                data.append('location', 'm3-offers');

                if (this.file1) {
                    data.append('offer_1', this.file1)
                    data.append('offer_1_id', this.form.subcategories.acquisitions.offer_1.id)
                }

                if (this.file2) {
                    data.append('offer_2', this.file2)
                    data.append('offer_2_id', this.form.subcategories.acquisitions.offer_2.id)
                }

                return data;
            },

            valueChangedForUnitPriceWithoutVat() {

                this.form.subcategories.acquisitions.pret_unitar_fara_tva = this.unitPriceWithoutVat;

                this.calculateFaraTVA();

                this.unitPriceWithVat = parseFloat(this.form.subcategories.acquisitions.pret_unitar_cu_tva).toFixed(2);
            },

            valueChangedForUnitPriceWithVat() {

                this.form.subcategories.acquisitions.pret_unitar_cu_tva = this.unitPriceWithVat;

                this.calculateCuTVA();

                this.unitPriceWithoutVat = parseFloat(this.form.subcategories.acquisitions.pret_unitar_fara_tva).toFixed(2);
            },
            checkLength(item) {
                return !!(item && item.length > 0)
            },
            checkInputsForNegativeValues() {
                this.negativeNumbers.eligible = this.form.subcategories.acquisitions.eligible < 0
                this.negativeNumbers.neeligible = this.form.subcategories.acquisitions.neeligible < 0
                this.negativeNumbers.pret_unitar_cu_tva = this.form.subcategories.acquisitions.pret_unitar_cu_tva < 0
                this.negativeNumbers.pret_unitar_fara_tva = this.form.subcategories.acquisitions.pret_unitar_fara_tva < 0
                this.negativeNumbers.cantitate = this.form.subcategories.acquisitions.cantitate < 0
                this.negativeNumbers.cota_tva = this.form.subcategories.acquisitions.cota_tva < 0
                this.negativeNumbers.contribution_total = this.form.subcategories.acquisitions.contribution_total < 0
                this.negativeNumbers.first_year_percentage = this.form.subcategories.acquisitions.first_year_percentage < 0
                this.negativeNumbers.second_year_percentage = this.form.subcategories.acquisitions.second_year_percentage < 0
            }
        },
    };
</script>

<style>
@media (max-width: 1800px) {
    .wrap-medium {
        display: block !important;
    }

    .wrap-medium-inputs .medium-input {
        max-width: 100% !important;
    }
    .width100Mobile{
        width: 100%;
        max-width: 100%;
    }
}

.custom-file-input ~ .custom-file-label::after {
    content: 'Caută' !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.width80 {
    width: 80%;
}

.btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: inherit !important;
}

.btn-outline-primary {
    color: #2b3c60;
    border-color: #91d4ca;
}

.btn-outline-primary:hover, .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
    color: #2b3c60;
    background-color: #91d4ca;
    border-color: #91d4ca;
}

.modal-xxxl {
    max-width: 1850px;
}

.modal-menu input {
    margin-top: 0 !important;
}

.no-user-spendings {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #d0d0d0;
}

.has-search-icon {
    position: relative;
}

.has-search-icon input::placeholder {
    opacity: 0.6;
}

.has-search-icon svg {
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    color: #212121;
    opacity: 0.6;
}

#gradientModal .modal-content,
#gradientModal .modal-body,
#gradientModal .modal-body .b-overlay-wrap,
#gradientModal .modal-body .flex-mobilee{
    height: 75vh;
    max-height: 900px;
    overflow: hidden;
}

#gradientModal .modal-content {
    background-color: transparent;
    display: flex;
}

#gradientModal .modal-menu {
    width: 32%;
    padding: 20px;
    background: #e7ebf1;
    color: #fff;
    overflow-y: auto;
    max-height: 95vh;
}
.modal-menu-height{
    max-height: 70vh;
}

#gradientModal .modal-body-content {
    width: 68%;
    padding: 20px;
    max-height: 94vh;
    overflow-y: scroll;
    background: linear-gradient(to bottom, #955a72ab, #71869ed1) !important;
    backdrop-filter: blur(4px);
}

#gradientModal___BV_modal_backdrop_ {
    background-color: transparent !important;
}

#gradientModal .modal-dialog .bg-gradient-color {
    position: relative;
    padding: 0;
    border-radius: 13px;
    max-height: 95vh;
    border: 2px solid #fff;
}

#gradientModal .modal-dialog .opacityNone {
    background-color: rgba(21, 20, 20, 0.00) !important;
    border: none !important;
    position: relative;
}

#gradientModal .btn-danger {
    border-color: var(--dangerColor);
    color: var(--dangerColor);
}

#gradientModal .btn-success {
    border-color: #0cc2aa;
    background-color: #0cc2aa;
}

#gradientModal___BV_modal_header_ {
    display: none;
}

#gradientModal .modal-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;

}

#gradientModal .modal-content {
    border: none;
    background-color: transparent !important;
}
</style>
<style scoped>

.custom-loading-overlay{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.custom-loading-overlay p{
    color: #000;
    font-size: 14px;
}

.select-year-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}
.select-year-wrapper >>> label {
    width: 49%;
    margin: 0!important;
    min-width: auto!important;
}
.close-add-achizitie {
    cursor: pointer;
}
.mobileColumn {
    margin: 0px 5px;
    align-items: flex-end;
}
.text-danger {
    color: #fff !important;
    background: #dc3545 !important;
    font-size: 12px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}

.modal-dialog.modal-xl {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

p {
    color: #fff;
}

.title, .modal-header {
    font-size: 16px;
    display: flex;
    justify-content: center;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px !important;
    padding: 0 18px !important;
}
.black-title{
    font-size: 17px;
    color: rgba(113, 134, 158, 0.81);
    margin-top: 0 !important;
    margin-bottom: 10px !important;
}
.black-color >>> *{
    color: rgba(113, 134, 158, 0.81) !important;
}
.black-color >>> legend {
    color: rgba(113, 134, 158, 0.81) !important;
}
.modal-header {
    padding: 0px 4px 0px 18px !important;
}

.flex-end {
    align-items: flex-end;
}

.black-button {
    background: #212121;
    color: #fff;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    padding: 6px 30px;
    width: 100%;
    max-width: 260px;
    position: relative;
    cursor: pointer;
}

.black-button:hover {
    background: #0e0e0e;
}
.min-width-desktop{
    min-width: 660px;
}
.blue-button {
    background: #25c9ab;
    border: 1px solid #25c9ab;
    color: #fff;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    padding: 6px 30px;
    width: 100%;
    max-width: 260px;
    position: relative;
    cursor: pointer;
}

.blue-button:hover {
    background: #20b79b;
    border-color: #20b79b;
}

.v-select >>> .vs__actions {
    right: 0;
    position: relative;
    padding: 0;
}

.v-select >>> .vs__dropdown-toggle {
    cursor: text;
    max-height: 33.5px;
    align-items: center;
    font-size: 13px;
    color: #2b3c60;
    font-weight: 500;
}
.smis-hub-vector{
    max-width: 208px;
}

.v-select >>> .vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 41px);
}

.v-select >>> .vs__dropdown-menu {
    background: #fff;
    font-size: 13px;
    overflow-x: hidden;
}

.v-select >>> .vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    margin-top: 2px;
}

/*.modal-menu li {
    font-size: 12px;
    color: #fff;
    border-bottom: 1px solid #fff;
    padding: 6px 10px;
}*/

.modal-menu ul {
    max-height: 715px;
    overflow: auto;
}
.flex-menu-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
}
.flex-menu-header >>> .form-group{
    width: 100%;
    max-width: 335px;
}
.flex-menu-header >>> input{
    border-radius: 6px;
}
.reper-title{
    width: 100%;
    background: #9197ab;
    font-size: 14px;
    font-weight: 600;
    color: #e7ebf1;
    padding: 10px 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: 0.3s;
}
.reper-title:hover{
    background: #848a9f;
}
.green-title{
    background: #49cda8 !important;
}

/* REPERE CAUTATE */
.flex-repers{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}
.search-reper{
    padding: 5px 15px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    min-height: 82px;
    width: 100%;
    max-width: 267px;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.3s;
}
.search-reper:hover{
    background: #f1f1f1;
}
.reper-label{
    position: absolute;
    content: '';
    width: 6px;
    height: 100%;
    left: 0;
    bottom: 0;
    background: #49cda8;
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
}
.gray-label{
    background: #cdd2e3 !important;
}
.red-label{
    background: #ff4141 !important;
}
.reper-image img{
    max-width: 60px;
    max-height: 60px;
    object-fit: contain;
}
.reper-info p{
    font-size: 12px;
    color: #9197ab;
}
.reper-info .gray-leaf{
    filter: grayscale(1);
}


.reper-title >>> svg{
    font-size: 18px;
}
#checkoutModal .modal-xl {
    max-width: 1640px;
}

.modal-body {
    padding: 0;
    overflow: hidden;
}

.modal-body > > > .pay-logo {
    position: absolute;
    top: 0;
    left: 0;
}

.modal-header span {
    font-size: 17px;
    color: #fff;
}

.modal-header svg {
    color: #fff;
    margin-left: 10px;
}

.modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}

.new-company-form {
    margin-top: 70px;
    width: 48%;
    position: relative;
}

.text-align-right span {
    text-align: right;
    margin-right: 10px;
}

.new-company-form:nth-child(2):before {
    content: 'Informații reprezentant legal (pentru contract)';
    color: #fff;
    position: absolute;
    top: -9%;
    font-size: 13px;
    font-weight: 600;
}

.modal-pas {
    padding: 0 50px;
    margin-top: 20px;
}

.modal-menu input {
    margin-top: 55px;
}

input {
    background: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    color: #2b3c60;
    font-size: 13px;
    text-align: center;
}

.form-control[readOnly] {
    color: #2b3c60;
}

input::placeholder {
    color: #2b3c60;
}

input:focus {
    box-shadow: none;
    background-color: #fff;
    border-color: #2b3c60;
    color: #2b3c60;
}

.delete-button {
    cursor: pointer;
}

.space-between {
    justify-content: space-between;
}

.flex {
    display: flex;
}

.inputs-group >>> fieldset > div {
    position: relative;
    line-height: 16px;
}

.form-group {
    margin-bottom: 0;
}

.form-group >>> legend {
    font-size: 12px;
    color: #fff;
}

.form-group >>> input,
.form-group >>> textarea,
.form-group >>> .form-file-text {
    border-radius: 3px;
    font-size: 13px;
    color: #2b3c60;
    text-align: left;
    font-weight: 500;
}

.form-group >>> .form-file-text {
    margin-top: 3px;
}

.checkMark {
    position: absolute;
    top: 0;
    right: 10px;
    max-height: 10px;
    -o-object-fit: cover;
    object-fit: cover;
    bottom: 0;
    margin: auto 0;
}

.small-input {
    max-width: 69.5px;
    margin: 0 5px;
}

.percent-input {
    width: 50%;
}

.small-medium-input {
    max-width: 213px;
    margin: 0 5px;
}

.checkbox >>> label{
    font-size: 14px;
}

.medium-input {
    width: 100%;
    max-width: 160px;
    margin: 0 5px;
}

.medium-input.info-text {
    max-width: 100px;
}

.medium-large-input {
    /*max-width: 300px;*/
    margin: 0 5px;
    width: 100%;
}

.radio-buttons-years {
    max-height: 35px;
    font-size: 13px;
}

.radio-buttons-years >>> label {
    font-size: 13px;
    padding: 6px 15px;
    background: #fff;
    min-width: 160px;
    border-color: #fff;
    font-weight: 700;
    border-radius: 4px !important;
}

.radio-buttons-years >>> label:first-child {
    margin-right: 15px;
}

.full-width-input {
    width: 100%;
    /*margin: 0 5px;*/
}

.align-items-start {
    justify-content: flex-start !important;
}

.info-text {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 100%;
    height: 100%;
    font-size: 12px;
}

.white-text {
    font-size: 12px;
    color: #fff;
}

.bottom-row-inputs {
    max-width: 650px;
    width: 100%;
}

.upload-button {
    background: #fff;
    border-radius: 4px;
    color: #2b3c60;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-height: 35px;
    cursor: pointer;
    margin-bottom: 10px;
}

.upload-button svg {
    margin-left: 10px;
}

.reference-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 2fr));
    grid-gap: 20px 15px;
}

.smis-hub-button {
    background: #fff;
    padding: 20px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    width: 100%;
    justify-content: space-between;
    transition: 0.4s;
    cursor: pointer;
    min-height: 130px;
}

.smis-hub-button:hover {
    box-shadow: rgb(71 73 74 / 34%) 0px 3px 11px;
}

.smis-hub-button p {
    color: #69728c;
    font-size: 14px;
}

.smis-hub-error {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}

.smis-hub-error img {
    margin-right: 5px;
}

.offerIcons {
    margin-top: 35px;
    padding-left: 5px;
    padding-right: 20px;
    color: #ffffff;
    font-size: 18px;
}

.is-invalid {
    background: #ffa5a5;
    border-width: 2px;
}

.is-invalid >>> .vs__dropdown-toggle {
    background: #ffa5a5;
    border: 2px solid #dc3545;
}

.check-mark-reper {
    margin-left: 10px;
}

.personal-reper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 6px;
    padding: 5px 15px;
    cursor: pointer;
    transition: 0.3s;
    margin-bottom: 8px;
    min-height: 31px;
}
.personal-reper:hover{
    background: #f1f1f1;
}
.personal-reper span{
    color: #9197ab;
    font-size: 12px;
}
.reper-actions .green-price-small{
    font-size: 14px;
    font-weight: 500;
}
.reper-actions >>> svg{
    color: #9197ab;
    font-size: 18px;
}
.reper-one-action{
    justify-content: flex-end !important;
}
.reper-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 100px;
    width: 100%;
}

.green-price-small {
    color: #99cdc4;
    font-weight: 600;
    font-size: 13px;
}

.white-background{
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    width: 100%;
    max-width: 650px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.no-space-left {
    padding-left: 0!important;
}
.w-60{
    width: 60%;
}
@media (max-width: 1600px) {
    .wrap-elements {
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    .wrap-medium-inputs .medium-input{
        max-width: 49% !important;
    }
    .smis-hub-button p{
        font-size: 12px;
        text-align: left;
    }
    .w-60{
        width: 53%;
    }
    .mobileWrap{
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
}

@media (max-width: 1500px) {
    .upload-files-wrapper {
        width: 100%;
        flex-wrap: nowrap;
        flex-direction: column;
    }
    .form-content >>> .medium-input, .form-content >>> .small-input, .form-content >>> .form-group, .form-content >>> .small-medium-input{
        padding: 0 !important;
    }
    .form-content >>> .medium-input >>> span, .form-content >>> .small-input >>> span, .form-content >>> .form-group >>> span, .form-content >>> .small-medium-input >>> span{
        margin-top: 0 !important;
    }
    .form-content >>> .width100Mobile span{
        padding: 0 !important;
    }
    .form-content >>> .full-w-responsive span{
        padding: 0 5px !important;
    }
    .form-content >>> .width100Mobile span:first-child{
        margin-right: 10px !important;
    }
    .mobilePl, .center-forms{
        padding: 0 !important;
    }

    .modal-header{
        padding-left: 0 !important;
    }
    .mobileFlexToo, .mobileFlexToo .flex{
        display: flex !important;
        align-items: center;
    }
    .smallMobilePl{
        padding: 0 5px !important;
    }
    .mobilePl span{
        padding: 0 !important;
    }
    .noMarginMobile{
        margin-top: 0 !important;
    }
    .marginSmallMobile .smis-hub-button{
        margin-top: 30px !important;
    }
    .upload-files-wrapper .col-md-6.flex {
        max-width: 100%!important;
        /*padding-right: 15px!important;*/
    }
    .upload-files-inner {
        max-width: 100%!important;
    }
    .years-inner-wrapper {
        justify-content: space-between;
    }
    /*.years-wrapper .mobile-column {
        padding: 0px 15px!important;
    }*/
    .years-wrapper .white-text {
        padding-left: 0!important;
    }
    .percent-inputs-wrapper {
        flex-wrap: nowrap!important;
    }
    .percent-inputs-wrapper .percent-input {
        padding:0!important;
    }
    .smis-hub-button-wrapper {
        padding: 0px 15px;
    }
    .mobileColumn.pl-3 {
        padding-left: 0!important;
        margin: 0;
    }
    .mobileColumn .w-50 {
        width: 100%!important;
        margin-right: 0!important;
        max-width: 100% !important;
    }
    .mobileColumn .w-60 {
        width: 100%!important;
        margin-right: 0!important;
    }
    .full-w-responsive {
        width: 100% !important;
    }
    .flex {
        flex-wrap: wrap;
    }

    #gradientModal .modal-body-content{
        max-height: 100%;
    }

    .col-lg-5 {
        max-width: 100% !important;
        flex: auto;
    }

    .inputs-group >>> span {
        width: 100% !important;
        max-width: 100%;
        /*padding: 0 15px !important;*/
        margin-top: 10px;
    }

    .v-select >>> .vs__dropdown-toggle {
        margin-bottom: 0;
    }

    .first-input >>> fieldset {
        padding: 0 15px !important;
        margin-top: 0;
    }

    .padding-left-mobile {
        padding-left: 15px !important;
    }

    .padding-right-mobile {
        padding-right: 15px !important;
    }

    .flex .title {
        margin-top: 20px !important;
    }
    .inputs-group > div{
        height: fit-content;
    }
    .col-md-12{
        padding: 0 !important;
    }
    .width80{
        width: 100%;
    }
    .white-background{
        max-width: 100%;
        height: auto;
        min-height: 200px;
    }
    .smis-hub-button{
        margin-top: 70px;
    }
    .medium-large-input{
        max-width: 100% !important;
        margin: 0 !important;
        width: 100% !important;
    }
    .margin-mobile-top{
        margin-top: 20px;
    }
}

@keyframes blinker {
    to {
        opacity: 0.2;
    }
}

@media (max-width: 1300px) {
    #gradientModal .modal-dialog {
        position: relative;
    }
    .mobile-column {
        flex-direction: column;
        margin-bottom: 15px;
    }
    .mobile-column .flex:last-child .medium-input >>> legend {
        min-height: inherit !important;
    }
    .mobile-column .form-group {
        width: 100% !important;
        max-width: 100%;
    }
    .mobile-column .flex-column {
        margin-top: 15px;
    }
    /*.mobile-column .medium-input >>> legend, .mobile-column .small-input >>> legend, .mobile-column .small-medium-input >>> legend {
        min-height: 43px;
    }*/
}

@media (max-width: 1100px) {
    .flex {
        display: block;
    }
    .flex-mobilee {
        display: flex;
    }
    .new-company-form {
        width: 100%;
    }
    .new-company-form:before {
        top: -30% !important;
    }
    .modal-header {
        padding-top: 50px;
    }

}

@media (max-width: 1500px) {
    .mobileColumn {
        flex-direction: column;
    }
    .bottom-row-inputs {
        max-height: 80px;
    }
}

.mediuRadio >>> .btn-outline-primary {
    width: 50%;
    font-size: 12px;
    background-color: white;
    color: #69728c;
}
</style>
